import { Sparkles, TrendingUp, Shield } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative pt-32 pb-20 px-4 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 opacity-20">
        <div className="w-full h-full bg-gradient-to-r from-pink-200 via-green-200 to-pink-300" style={{ backgroundImage: 'url("/images/markus-spiske-gvGlAAIvIBg-unsplash.jpg")', backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
      </div>

      <div className="container mx-auto relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-block mb-4">
            <div className="glass-strong px-6 py-2 rounded-full inline-flex items-center space-x-2">
              <Sparkles className="w-5 h-5 text-pink-600" />
              <span className="text-sm font-semibold text-gray-700">UK's Most Trusted Casino Aggregator</span>
            </div>
          </div>
          
          <h1 className="pb-2 text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-pink-600 via-pink-500 to-green-600 bg-clip-text text-transparent">
            Discover Your Perfect Casino Experience
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-700 mb-8 leading-relaxed">
            Expert reviews, exclusive bonuses, and trusted recommendations for the UK's finest online casinos. 
            Find your winning destination today.
          </p>

          <div className="flex flex-wrap justify-center gap-6 mb-12">
            <div className="glass p-6 rounded-2xl min-w-[200px]">
              <TrendingUp className="w-8 h-8 text-green-600 mx-auto mb-2" />
              <div className="text-2xl font-bold text-gray-800">500+</div>
              <div className="text-sm text-gray-600">Casinos Reviewed</div>
            </div>
            <div className="glass p-6 rounded-2xl min-w-[200px]">
              <Shield className="w-8 h-8 text-green-600 mx-auto mb-2" />
              <div className="text-2xl font-bold text-gray-800">100%</div>
              <div className="text-sm text-gray-600">Licensed Operators</div>
            </div>
            <div className="glass p-6 rounded-2xl min-w-[200px]">
              <Sparkles className="w-8 h-8 text-pink-600 mx-auto mb-2" />
              <div className="text-2xl font-bold text-gray-800">£10M+</div>
              <div className="text-sm text-gray-600">Bonus Value</div>
            </div>
          </div>

          <a 
            href="#offers" 
            className="inline-block px-8 py-4 bg-gradient-to-r from-pink-600 to-green-600 text-white font-semibold rounded-full hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
          >
            Explore Top Casinos
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;

